<main class="tw-max-h-full">
  <section class="tw-header">
    <div class="tw-flex tw-flex-col tw-px-[52px] tw-pt-10">
      <h2 class="tw-text-2xl tw-font-semibold tw-mb-2">DCT event form</h2>
      <h5 class="tw-text-gray-600 tw-mb-4">Please fill in the DCT required data for the event.</h5>
      <div class="tw-flex tw-flex-col tw-justify-around" [formGroup]="form">
        <!-- TODO: Add report button when needed
        <div class="tw-mb-3 tw-flex tw-items-baseline">
          <div class="tw-w-full tw-flex tw-justify-end tw-p-0 tw-pl-3 tw-pr-3">
            <span [ngxTippy]="!isEventFinished() ? 'Please come back as soon as the event finishes to view the report' : 'Open the DCT report'">
              <button
                class="tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md hover:tw-bg-blue-700 focus:tw-outline-blue-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-self-end"
                type="submit"
                (click)="openReport()"
                [disabled]="!isEventFinished()"
              >
                <i class="fas fa-file-alt"></i>
                DCT report
              </button>
            </span>
          </div>
        </div>
        -->
        @if (!isLoading()) {
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 lg:tw-grid-cols-4 tw-gap-4 tw-mb-4 tw-items-center tw-justify-start">
          <div class="md:tw-col-span-1">
            <input
              formControlName="eventId"
              type="text"
              class="tw-block tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-blue-500 disabled:tw-bg-gray-200"
              id="dct-event-id"
              placeholder="Enter DCT Event ID"
              required
              (keydown.enter)="fetchDCTMapping()"
            />
          </div>
          <div class="tw-flex tw-justify-end md:tw-col-span-3">
            <button
              class="tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md hover:tw-bg-blue-700 focus:tw-outline-blue-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-self-end"
              [disabled]="form.invalid || (form.pristine && isEventIdSubmitted())"
              type="submit"
              (click)="fetchDCTMapping()"
            >
              <i class="fas fa-file-alt"></i> Submit DCT Event ID
            </button>
          </div>
        </div>
        } @else {
        <ngx-loading-dialog></ngx-loading-dialog>
        }
      </div>
    </div>
  </section>
  @if(isEventIdSubmitted()) {
  <section class="products tw-mx-[52px] tw-pr-2" [class.show]="!isLoading()">
    @for (persona of personas(); track persona.id) {
    <ngx-dct-product
      [persona]="persona"
      [dctSettings]="dctSettings()"
      [isConnected]="persona.options?.dct?.eventId ? true : false"
      (productConnected)="connectPersona(persona, $event)"
      (productDeleted)="disconnectPersona(persona)"
    ></ngx-dct-product>
    }
  </section>
  }
</main>
